import React from 'react';
import './Services.css';
import SEO from './SEO';

const Services = () => {
  const countries = [
    {
      name: "United Arab Emirates (Dubai) 🇦🇪",
      description: "The United Arab Emirates offers golden visas, free zones for business setup, and tax-free living. Dubai and Abu Dhabi are popular expat destinations with world-class infrastructure.",
      buttonText: "Move to the UAE & pay 0% tax",
      link: "https://genzone.com/tk?website=services"
    },
    {
      name: "Singapore 🇸🇬",
      description: "Known for its efficient government and high quality of life, Singapore offers various work passes and permanent residency options for qualified professionals and investors.",
      buttonText: "Move to Singapore",
      link: "https://osome.com/sg/referral/incorporation/?ref=zmi2njgw&aff_name=Tuomas+Kiv&coupon=TK16"
    },
    {
      name: "Indonesia (Bali) 🇮🇩",
      description: "With its new digital nomad visa and affordable cost of living, Indonesia is attracting remote workers. Bali remains a top destination for expats seeking tropical living.",
      buttonText: "Get an Indonesia Residence Permit",
      link: "https://apply.balivisas.com/submission/kitas?referral=tuomas-kivioja"
    },
    {
      name: "Thailand 🇹🇭",
      description: "Thailand offers retirement visas, elite visas, and business visas. Known for its low cost of living, rich culture, and beautiful beaches.",
      buttonText: "Get a Thailand Residence Permit",
      link: "https://www.siam-legal.com/thailandelite/?ref=48"
    },
    {
      name: "Hong Kong 🇭🇰",
      description: "A global financial hub with excellent career opportunities. Hong Kong offers quality visas for professionals, investors, and entrepreneurs.",
      buttonText: "Form a Hong Kong Company",
      link: "https://osome.com/hk/referral/16off/?ref=zmi2njgv&aff_name=Tuomas+Kiv&coupon=TKHK"
    },
    {
      name: "US LLC 🇺🇸",
      description: "Form a US LLC, a 0% tax USA company structure with light reporting requirements.",
      buttonText: "Form a US LLC as a non Resident",
      link: "https://genzone.com/usa-llc-tk/?website=services"
    },
    {
      name: "Mexico 🇲🇽",
      description: "Mexico offers residency for retirees, high earners, and investors. Known for its beautiful beaches, rich culture, and low cost of living.",
      buttonText: "Get Mexico Residency",
      link: "/mexico-residency"
    },
    {
      name: "Qatar 🇶🇦",
      description: "Qatar offers an easy path to residency for business owners. Book a call for more information.",
      buttonText: "Move to the Qatar",
      link: "https://calendly.com/rezahooda/tax-residency-consultation-qatar-45m"
    },
    {
      name: "Citizenship by Investment",
      description: "Compare the best citizenship by investment programs in the world.",
      buttonText: "Get a 2nd Passport",
      link: "https://apply.vanciscapital.com/tuomas"
    }
  ];

  const handleButtonClick = (link) => {
    // You can add tracking or other logic here before navigation
    window.open(link, '_blank');
  };

  return (
    <div className="relocation-services">
      <SEO
        title="Relocation Services - UAE, Singapore, Mexico, US LLC | Internet Made Media FZCO"
        description="Compare international relocation and company setup services by Internet Made Media FZCO: UAE 0% tax company setup, Singapore incorporation, Mexico residency, Thailand elite visa, Indonesia Bali visa, Hong Kong company formation, US LLC for non-residents, and citizenship by investment programs."
        keywords="Internet Made Media FZCO, relocation services, UAE company setup, Singapore incorporation, Mexico residency, US LLC formation, Thailand visa, Bali visa, Hong Kong company, citizenship by investment, international business setup, expat services"
        canonical="https://tuomaskivioja.com/relocation-services"
        ogImage="https://tuomaskivioja.com/logo512.png"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "International Relocation Services",
          "provider": {
            "@type": "Organization",
            "name": "Internet Made Media FZCO"
          },
          "description": "Comprehensive international relocation and company setup services",
          "areaServed": ["AE", "SG", "MX", "US", "TH", "ID", "HK"],
          "url": "https://tuomaskivioja.com/relocation-services"
        }}
      />
      <h2>Relocation, Citizenship & Company Setup Services</h2>
      <div className="countries-container">
        {countries.map((country, index) => (
          <div key={index} className="country-card">
            <h3>{country.name}</h3>
            <p>{country.description}</p>
            <div className="services-button-container">
              <a href={country.link} className="country-link">
                <button 
                  className="country-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    handleButtonClick(country.link);
                  }}
                >
                  {country.buttonText}
                </button>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
